import { render, staticRenderFns } from "./TaskSuggest.vue?vue&type=template&id=c36350b0&scoped=true"
import script from "./TaskSuggest.vue?vue&type=script&lang=js"
export * from "./TaskSuggest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36350b0",
  null
  
)

export default component.exports